module.exports = __webpack_public_path__ + "src/img/del.b74ea198.svg";